import React from "react";
import { motion } from "framer-motion";
import "./MySkillComponent.css";
import AnimatedGradientText from "./AnimatedGradient";
import { useSelector } from "react-redux";

const cardVariants = {
  initial: {
    scale: 1,
    backgroundColor: "rgba(44, 44, 44, 0.4)",
    color: "#E0E0E0",
  },
  hover: {
    scale: 1.05, // Subtle bounce effect
    color: "#000000",
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 15,
    },
  },
};

const fillVariants = {
  initial: {
    scaleX: 0,
  },
  hover: {
    scaleX: 1,
    transition: {
      duration: 0.2,
      ease: "easeOut",
    },
  },
};

const MySkillComponent = ({ skillsRef }) => {
  const { profile } = useSelector((state) => state.editMyTechProfileStore);
  return (
    <div ref={skillsRef} className="mytechprofile_myskillcomponent-container">
      <div className="mytechprofileproject-header">
        <h3 className="mytechprofileproject-subtitle">I am Good At</h3>
        <h1 className="mytechprofileproject-title">
          My <AnimatedGradientText text="Skills" />
        </h1>
      </div>

      <div className="mytechprofile_myskillcomponent-grid">
        {profile?.selectedSkills?.map((skill) => (
          <motion.div
            key={skill?.name}
            className="mytechprofile_myskillcomponent-skill-card"
            variants={cardVariants}
            initial="initial"
            whileHover="hover"
          >
            {/* Background fill animation layer */}
            <motion.div
              className="mytechprofile_myskillcomponent-fill"
              variants={fillVariants}
            />

            {/* Content layer */}
            <div className="mytechprofile_myskillcomponent-card-content">
              <img
                src={skill?.icon}
                alt={`${skill?.name} logo`}
                className="mytechprofile_myskillcomponent-skill-logo"
              />
              <p className="mytechprofile_myskillcomponent-skill-name">
                {skill?.name}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default MySkillComponent;
